"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const NoData = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "no-data", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "no-data", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M16 0c4.09-.002 7.9 2.007 10.106 5.33 2.205 3.325 2.505 7.504.794 11.09a11.575 11.575 0 0 1-.943 1.541l-9.553 13.83a.498.498 0 0 1-.812 0l-9.63-13.918a10.736 10.736 0 0 1-.817-1.362 11.227 11.227 0 0 1 .721-11.138C8.068 2.025 11.893-.003 16.001 0z", fill: "#8B8B8B" }) })) })));
};
exports.NoData = NoData;
